import "core-js/stable";
import React from 'react'
import ReactDOM from 'react-dom'
import QuotebuilderV3 from '../components/quote-v3';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { HttpClient } from "@sentry/integrations";
//import { CaptureConsole } from "@sentry/integrations";


const quotebuilder = document.querySelector('#cpt-quote-builder');
const environment = quotebuilder.getAttribute('data-environment');

Sentry.init({
  dsn: "https://ee9ac26bb065e8c4614481e4778a1943@o4508879362916352.ingest.de.sentry.io/4508879576367184",

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  //new CaptureConsole()
  tracesSampleRate: 1.0,
  environment: environment,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  attachStacktrace: true,
  tracesSampleRate: 1.0,
  integrations: [
  	new BrowserTracing(), 
  	new Sentry.Replay({
		maskAllText: false,
		blockAllMedia: false,
		maskAllInputs: true
	}), 
  	new HttpClient() 
  ],
  sendDefaultPii: true, //report XHR request and response
});


const  FallbackComponent = ()  => {
  return (
  	  <div>An error has occurred</div>
  )
}

const myFallback = () => <FallbackComponent />;

//location data
const locationElement = document.querySelector('#cpt-location-data');
const locationJson = locationElement.textContent || locationElement.innerText; // fallback for IE ≤ 8
const locationData = JSON.parse( locationJson );

const userElement = document.querySelector('#cpt-user-data');
const userJson = userElement.textContent || userElement.innerText; // fallback for IE ≤ 8
const userData = JSON.parse( userJson );

const hasBookings = quotebuilder.getAttribute('data-has-bookings') == 'true' ? true : false;

//render
ReactDOM.render( <Sentry.ErrorBoundary fallback={myFallback} showDialog>
					<QuotebuilderV3 destination={locationData} user={userData} hasBookings={hasBookings} />
				</Sentry.ErrorBoundary>, quotebuilder);
